<template>
    <div class="user-photos-selector">
        <div class="grid-col" v-if="images">
            <div
                class="img-profile animate-size p-relative cursor-pointer"
                :key="img.id"
                v-lazy:background-image="img.photo_url"
                v-for="img in images"
                @click="onClickImage(img)"
            >
                <Checkbox class="white" v-model="img.checked" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserPhotosSelector',
    props: ['user'],
    watch: {
        user() {
            this.initImages()
        },
    },
    data: () => ({
        images: [],
    }),
    mounted() {
        this.initImages()
        this.$bus.$on('onPhotosSent', this.onPhotosSent)
        this.$bus.$on('onRequireSelectAllPhotos', this.onRequireSelectAllPhotos)
    },
    beforeDestroy() {
        this.$bus.$off('onPhotosSent', this.onPhotosSent)
        this.$bus.$off('onRequireSelectAllPhotos', this.onRequireSelectAllPhotos)
    },
    methods: {
        initImages() {
            this.images = ((this.user || {}).photos || []).map(p => ({
                photo_url: p.url,
                checked: false,
            }))
        },
        onClickImage(img) {
            img.checked = !img.checked
            this.$emit(
                'onPhotos',
                this.images.filter(image => image.checked)
            )
        },
        onPhotosSent(photos) {
            this.images
                .filter(img => photos.some(photoUrl => photoUrl === img.photo_url))
                .forEach(img => {
                    img.checked = false
                })
        },
        onRequireSelectAllPhotos() {
            this.images.forEach(img => {
                img.checked = true
            })
            this.$emit('onPhotos', this.images)
        },
    },
}
</script>
